import { useEffect, useState } from 'react';
import './MemoryGame.css';
import { Link } from 'react-router-dom'
import SingleCard from '../../components/SingleCard';
import { useTheme } from '../../hooks/useTheme'

const cardImages = [
  {"src": "https://i.imgur.com/ZoW6oz8.png", matched: false},
  {"src": "https://i.imgur.com/Xmc20JN.png", matched: false},
  {"src": "https://i.imgur.com/WEM7df6.png", matched: false},
  {"src": "https://i.imgur.com/dodehv4.png", matched: false},
  {"src": "https://i.imgur.com/zdSoyNV.png", matched: false},
  {"src": "https://i.imgur.com/eRBNz7Z.png", matched: false}
]

function MemoryGame() {
  const { mode } = useTheme()

  const [cards, setCards] = useState([])
  const [turns, setTurns] = useState(0)
  const [choiceOne, setChoiceOne] = useState(null)
  const [choiceTwo, setChoiceTwo] = useState(null)
  const [disabled, setDisabled] = useState(false)

  // shuffle cards
  const shuffleCards = () => {
    const shuffledCards = [...cardImages, ...cardImages]
      .sort(()=> Math.random() - 0.5)
      .map((card)=> ({ ...card, id: Math.random() }))
    
    setChoiceOne(null)
    setChoiceTwo(null)
    setCards(shuffledCards)
    setTurns(0)
  }

  // handle a choice
  const handleChoice = ( card) => {
    choiceOne ? setChoiceTwo(card) : setChoiceOne(card)
  }

  // compare 2 selected cards
  useEffect(()=>{
    if(choiceOne && choiceTwo) {
      setDisabled(true)

      if(choiceOne.src === choiceTwo.src) {
        setCards(prevCards => {
          return prevCards.map(card => {
            if(card.src === choiceOne.src) {
              return {...card, matched: true}
            } else {
              return card
            }
          })
        })
        resetTurn()
      } else {
        setTimeout(()=> resetTurn(), 1000)
      }
    }
  }, [choiceOne, choiceTwo])


  // reset choices & increase turn
  const resetTurn = () => {
    setChoiceOne(null)
    setChoiceTwo(null)
    setTurns(prevTurns => prevTurns + 1)
    setDisabled(false)
  }

  // start game automagically
  useEffect(() => {
    shuffleCards()
  }, [])

  return (
    <div className={`memory-game ${mode}`}>
      <div className='breadcrumbs'>
          <Link to="/">
              <div className='link-crumb'>/Home </div>
          </Link>
          <Link to="/games">
              <div className='link-crumb'> /Games </div>
          </Link>
          <div className='link-crumb'> /My Favorite Match</div>
      </div>
      <h1>My Favorite Match</h1>
      <button onClick={shuffleCards}>New Game</button>
      <p>Turns: {turns}</p>
      <div className='card-grid'>
      {cards.map(card => (
        <SingleCard 
         key={card.id} 
         card={card} 
         handleChoice={handleChoice}
         flipped={card === choiceOne || card === choiceTwo || card.matched}
         disabled={disabled}
        />
      ))}
      </div>
      <Link to="/games">
         <div className='link'>&#8592; Back to all Games</div>
       </Link>
    </div>
  );
}

export default MemoryGame;